<div class="privacy-container">
  <div class="header">
    <h2>Paramètres de confidentialité</h2>
  </div>

  <mat-card>
    <mat-card-content>
      <div class="privacy-settings" *ngIf="!isLoading">
        <!-- Visibilité du profil -->
        <div class="setting-section">
          <h3>Visibilité du profil</h3>
          <p class="setting-description">Choisissez qui peut voir votre profil</p>
          <mat-radio-group class="radio-group" [(ngModel)]="privacySettings.profileVisibility" (change)="updatePrivacySettings()">
            <mat-radio-button class="radio-button" value="public">
              <div class="option-content">
                <div class="option-title">Public</div>
                <div class="option-description">Tout le monde peut voir votre profil</div>
              </div>
            </mat-radio-button>
            <mat-radio-button class="radio-button" value="friends">
              <div class="option-content">
                <div class="option-title">Amis uniquement</div>
                <div class="option-description">Seuls vos amis (followers mutuels) peuvent voir votre profil</div>
              </div>
            </mat-radio-button>
            <mat-radio-button class="radio-button" value="private">
              <div class="option-content">
                <div class="option-title">Privé</div>
                <div class="option-description">Seuls les utilisateurs que vous autorisez peuvent voir votre profil</div>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Messages -->
        <!--<div class="setting-section">
          <h3>Messages</h3>
          <p class="setting-description">Choisissez qui peut vous envoyer des messages</p>
          <mat-radio-group class="radio-group" [(ngModel)]="privacySettings.allowMessages" (change)="updatePrivacySettings()">
            <mat-radio-button class="radio-button" value="everyone">
              <div class="option-content">
                <div class="option-title">Tout le monde</div>
                <div class="option-description">N'importe qui peut vous envoyer des messages</div>
              </div>
            </mat-radio-button>
            <mat-radio-button class="radio-button" value="friends">
              <div class="option-content">
                <div class="option-title">Amis uniquement</div>
                <div class="option-description">Seuls vos amis peuvent vous envoyer des messages</div>
              </div>
            </mat-radio-button>
            <mat-radio-button class="radio-button" value="none">
              <div class="option-content">
                <div class="option-title">Personne</div>
                <div class="option-description">Personne ne peut vous envoyer de messages</div>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>-->

        <!-- Statut en ligne -->
        <div class="setting-section">
          <h3>Statut en ligne</h3>
          <p class="setting-description">Choisissez si les autres utilisateurs peuvent voir quand vous êtes en ligne</p>
          <mat-slide-toggle
            class="status-toggle"
            [(ngModel)]="privacySettings.showOnlineStatus"
            (change)="updatePrivacySettings()">
            {{ privacySettings.showOnlineStatus ? 'Visible' : 'Masqué' }}
          </mat-slide-toggle>
        </div>
      </div>

      <!-- Loading spinner -->
      <div class="loading-spinner" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</div>